import { NumberDecimalFormat } from '@components/shared/Format'
import { Constants } from '@models/Constants'
import { Store } from '@stores/Store'

export class BronzeIncentiveCalculation {
  store!: Store

  constructor(store: Store) {
    this.store = store
  }

  // Bronze Incentive

  get bronzeFoundationMultiplier(): number {
    const { store } = this
    const { countryData } = store

    return countryData.bronzeFoundationMultiplier
  }

  get bronzeBuilderMultiplier(): number {
    const { store } = this
    const { countryData } = store

    return countryData.bronzeBuilderMultiplier
  }

  get bronzeFoundationMonthlyBonusAmount(): number {
    const { store } = this
    const { bronzeIncentivesStore } = store
    const { bronzeFoundationActive, bronzeFoundationEnabled } = bronzeIncentivesStore

    if (!bronzeFoundationActive || !bronzeFoundationEnabled) { return 0 }
    if (this.bronzeFoundationIncentiveAmount > 0) {
      return NumberDecimalFormat(this.bronzeFoundationIncentiveAmount)
    }

    return 0
  }

  get bronzeFoundationAnnualBonusAmount(): number {
    return this.bronzeFoundationMonthlyBonusAmount * 12
  }

  get bronzeFoundationIncentiveAmount(): number {
    const { store } = this
    const { performanceBonus } = store

    if (this.bronzeFoundationFullBFCriteriaMet) {
      return performanceBonus * this.bronzeFoundationMultiplier
    }

    return 0
  }

  get bronzeFoundationFullBFCriteriaMet(): boolean {
    const { bronzeFoundationEligible, bronzeActualPBPercent, bronzeActualPPV, bronzeFoundation3x3PercentLegs } = this

    if (bronzeFoundationEligible &&
      bronzeActualPBPercent >= Constants.BRONZE_FOUNDATION_BF_PERCENT &&
      bronzeActualPPV >= Constants.BRONZE_MIN_ACTUAL_PPV &&
      bronzeFoundation3x3PercentLegs) {
      return true
    }

    return false
  }

  get bronzeFoundationEligible(): boolean {
    const { store } = this
    const { countryHelper } = store

    return countryHelper.bronzeFoundationEligible
  }

  get bronzeFoundation3x3PercentLegs(): boolean {
    const { store } = this
    const { computedFrontlines } = store

    const frontlinesBonusPercentLevel = computedFrontlines.filter((frontline) => frontline.bonusPercentLevel >= Constants.BRONZE_FOUNDATION_3x3_PERCENT_LEGS)
    return frontlinesBonusPercentLevel.length >= Constants.BRONZE_LEGS_MIN_LENGTH
  }

  get bronzeActualPPV(): number {
    const { store } = this
    const { personalPV } = store

    return personalPV
  }

  get bronzeActualPBPercent(): number {
    const { store } = this
    const { performanceLevelPercent } = store

    return performanceLevelPercent
  }

  get bronzeBuilderMonthlyBonusAmount(): number {
    const { store } = this
    const { bronzeIncentivesStore } = store
    const { bronzeBuilderActive, bronzeBuilderEnabled } = bronzeIncentivesStore

    if (!bronzeBuilderActive || !bronzeBuilderEnabled) { return 0 }
    if (this.bronzeBuilderIncentiveAmount > 0) {
      return NumberDecimalFormat(this.bronzeBuilderIncentiveAmount)
    }

    return 0
  }

  get bronzeBuilderAnnualBonusAmount(): number {
    return this.bronzeBuilderMonthlyBonusAmount * 12
  }

  get bronzeBuilderIncentiveAmount(): number {
    const { store } = this
    const { performanceBonus } = store

    if (this.bronzeBuilderFullBFCriteriaMet) {
      return performanceBonus * this.bronzeBuilderMultiplier
    }

    return 0
  }

  get bronzeBuilderFullBFCriteriaMet(): boolean {
    const { bronzeBuilderEligible, bronzeActualPBPercent, bronzeActualPPV, bronzeBuilder3x6PercentLegs } = this

    if (bronzeBuilderEligible &&
      bronzeActualPBPercent >= Constants.BRONZE_BUILDER_BB_PERCENT &&
      bronzeActualPPV >= Constants.BRONZE_MIN_ACTUAL_PPV &&
      bronzeBuilder3x6PercentLegs) {
      return true
    }

    return false
  }

  get bronzeBuilderEligible(): boolean {
    const { store } = this
    const { countryHelper } = store

    return countryHelper.bronzeBuilderEligible
  }

  get bronzeBuilder3x6PercentLegs(): boolean {
    const { store } = this
    const { computedFrontlines } = store

    const frontlinesBonusPercentLevel = computedFrontlines.filter((frontline) => frontline.bonusPercentLevel >= Constants.BRONZE_BUILDER_3x6_PERCENT_LEGS)
    return frontlinesBonusPercentLevel.length >= Constants.BRONZE_LEGS_MIN_LENGTH
  }

}
